import libraries from './content/reducers'
import documents from './document/reducers'

export default {
  libraries,
  documents,
}
